import "./styles.css";

const form = document.getElementById("form");
const table = document.querySelector("table");
const keyTypes = document.getElementsByName("key-type");
let MAX_INTEGER = Number(document.getElementById("integer-key-max").value);
document.getElementById("integer-key-max").oninput = (e) => {
  MAX_INTEGER = Number(e.target.value);
};

function getRandomString() {
  // stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript
  return (
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15)
  );
}

function getRandomSmallIntegerString() {
  return Math.floor(Math.random() * MAX_INTEGER).toString();
}

function getRandomNumericString() {
  return Math.random().toString();
}

const randomKeyByType = {
  "string-key": getRandomString,
  "numeric-key": getRandomNumericString,
  "integer-key": getRandomSmallIntegerString
};

class MemoryTest {}

const memoryTest = new MemoryTest();

form.addEventListener("submit", (e) => {
  e.preventDefault();
  const [SelectedKeyType] = Array.from(keyTypes).filter(
    (keyType) => keyType.checked
  );

  const getRandomKey = randomKeyByType[SelectedKeyType.value];

  const duration = Number(document.getElementById("duration").value);
  const width = Number(document.getElementById("width").value);
  const depth = Number(document.getElementById("depth").value);

  // measure insertion perf
  // warm up for object insertion
  measureFor(() => createObject(getRandomKey, width, depth), 100);
  const objectIters = measureFor(
    () => createObject(getRandomKey, width, depth),
    duration
  );

  // warm up for map insertion
  measureFor(() => createMap(getRandomKey, width, depth), 100);
  const mapInsertPerSec = measureFor(
    () => createMap(getRandomKey, width, depth),
    duration
  );
  // measure iteration perf
  const objToIterate = createObject(getRandomKey, width, depth);
  const objectIterPerSec = measureFor(
    () => iterateObject(objToIterate),
    duration
  );

  const mapToIterate = createMap(getRandomKey, width, depth);
  const mapIterPerSEc = measureFor(() => iterateMap(mapToIterate), duration);

  // measure deletion perf
  const objToDelete = createObject(getRandomKey, width, depth);
  let now = performance.now();
  deleteObject(objToDelete);
  const timeToDeleteObj = (performance.now() - now).toFixed(4);

  const mapToDelete = createMap(getRandomKey, width, depth);
  now = performance.now();
  deleteMap(mapToDelete);
  const timeToDeletemap = (performance.now() - now).toFixed(4);

  table.innerHTML = `
      <tbody><tr>
      <th>&nbsp;</th>
      <th>insert (n/s)</th>
      <th>iterate (n/s)</th>
      <th>delete (ms)</th>
    </tr>
    <tr>
      <td>Object</td>
      <td>${objectIters}</td>
      <td>${objectIterPerSec}</td>
      <td>${timeToDeleteObj}</td>
    </tr>
    <tr>
      <td>Map</td>
      <td>${mapInsertPerSec}</td>
      <td>${mapIterPerSEc}</td>
      <td>${timeToDeletemap}</td>
    </tr>
    </tbody> 
  `;

  // memory usage
  memoryTest.myObj = objToIterate;
  memoryTest.myMap = mapToIterate;
});

function measureFor(f, duration) {
  let iterations = 0;
  const now = performance.now();
  let elapsed = 0;
  while (elapsed < duration) {
    f();
    elapsed = performance.now() - now;
    iterations++;
  }

  return ((iterations / elapsed) * 1000).toFixed(4);
}

function createObject(getRandomKey, width, depth) {
  const obj = {};
  for (let i = 0; i < width; i++) {
    if (depth === 1) {
      obj[getRandomKey()] = i;
    } else {
      obj[getRandomKey()] = createObject(getRandomKey, width, depth - 1);
    }
  }

  return obj;
}

function createMap(getRandomKey, width, depth) {
  const map = new Map();
  for (let i = 0; i < width; i++) {
    if (depth === 1) {
      map.set(getRandomKey(), i);
    } else {
      map.set(getRandomKey(), createMap(getRandomKey, width, depth - 1));
    }
  }
  return map;
}

function deleteObject(obj) {
  for (const key in obj) {
    const value = obj[key];
    if (typeof value === "object") {
      deleteObject(obj[key]);
    }
    delete obj[key];
  }
}

function deleteMap(map) {
  for (const [key, value] of map) {
    if (typeof value === "object") {
      deleteMap(value);
    }
    map.delete(key);
  }
}

function iterateObject(obj) {
  for (const key in obj) {
    const value = obj[key];
    if (typeof value === "object" && value !== null) {
      iterateObject(value);
    }
  }
}

function iterateMap(map) {
  for (const [key, value] of map) {
    if (typeof value === "object" && value !== null) {
      iterateMap(value);
    }
  }
}
